<template>
  <div class="container__full-width rooms-listing">
    <h1 class="centered">{{organizationName}}</h1>

    <ul>
      <li v-for="room in rooms">
        <a :href="'/' + orgId + '?room=' + room.id">
          {{ room.roomName }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>

import {
  getDirectory
} from "../services/data";

export default {
  name: "Directory",
  data() {
    return {
      orgId: null,
      organizationName: "",
      rooms: []
    };
  },
  mounted() {
    let self = this;

    getDirectory(this.$route.params.roomId).then(function(results) {
      let data = results.data;

      self.organizationName = data.organization;
      self.orgId = data.id;
      self.rooms = data.rooms;
    });
  },
  methods: {

  }
};
</script>

<style scoped>
  .centered {
    text-align: center;
  }

  .rooms-listing {
    padding: 3em;
    overflow: overlay;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }

  ul {
    background: transparent;
    max-width: 500px;
    margin: 0 auto;
    list-style: none;
    margin-top: 2em;
  }

  a {
    display: block;
    padding: 1em;
    font-size: 18px;
    background: white;
    border: 1px solid #e4e4e4;
    border-radius: 10px;
    color: #177df7;
    font-weight: 700;
  }

  a:hover {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/Directory.vue